'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
/**
 *
 * Locale | Example output
 * --- | ---
 * `en-gb` | Thu 5 December 2019
 * `en-us` | Thu, December 5, 2019
 * `es` | jue, 5 de diciembre de 2019
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/date_format_new/date_with_short_weekday_with_year/name
 */
var form = 'date_with_short_weekday_with_year';
lingojsCore.registerDynamicTags(lingojsCore.t('date_format_new', form, 'name'));

module.exports = form;
//# sourceMappingURL=index.js.map
